import React, { useState, useEffect } from "react";
import { Form, Dropdown, Button, Checkbox } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../hook/userAuth";
import { ToastContainer, toast } from "react-toastify";
import { BASE_API } from "../../../ruta-server/BaseApi";
import "./TableManagers.css";
import { map } from "lodash";

export function AddEditManagers(props) {
  const { onClose, onRefetch, manager } = props;
  const [showPassword, setShowPassword] = useState(false);
  const [usuarios, setAdministrativos] = useState(null);
  const [refetch] = useState(false);
  const { auth } = useAuth();
  const [recommendedUsername, setRecommendedUsername] = useState("");
  const [cargos, setCargos] = useState(null);
  const [cargosFormato, setCargosFormat] = useState([]);
  const [categorias, setCategorias] = useState(null);
  const [categoriasFormato, setCategoriasFormato] = useState([]);

  async function getUsersApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/users/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setAdministrativos(result);
      return result;
    } catch (error) {
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    getUsersApi();
    // eslint-disable-next-line
  }, [refetch]);

  const addManager = async (data) => {
    try {
      await createManagerApi(data, auth.token);
    } catch (error) {
      throw error;
    }
  };

  const updateManager = async (id, data) => {
    try {
      await updateManagerApi(id, data, auth.token);
    } catch (error) {
      throw error;
    }
  };

  async function createManagerApi(data, token) {
    try {
      const url = `${BASE_API}/api/users/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.post(url, data, { headers });
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const existingUserByUsername = usuarios.find(
          (manager) => manager.username === data.username
        );
        const existingUserByCurp = usuarios.find(
          (manager) => manager.curp === data.curp
        );
        if (existingUserByUsername) {
          toast.error("Ya existe un directivo con ese nombre de usuario");
        } else if (existingUserByCurp) {
          toast.error("Ya existe un directivo con esa CURP");
        }
        if (error.response.data.email !== undefined) {
          toast.error("Ya existe un usuario con este correo electrónico");
        }
      }
      throw error;
    }
  }

  async function updateManagerApi(id, data, token) {
    try {
      const url = `${BASE_API}/api/users/${id}/`;
      const headers = {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.patch(url, data, { headers });
      window.location.reload();
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.curp !== undefined) {
          toast.error("campo de curp: " + error.response.data.curp[0]);
        }
        if (error.response.data.username !== undefined) {
          toast.error(
            "Campo de nombre de usuario: " + error.response.data.username[0]
          );
        }
        if (error.response.data.email !== undefined) {
          toast.error("Ya existe un usuario con este correo electrónico");
        }
      }
      throw error;
    }
  }

  const formatName = (value) => {
    const parts = value.split(" ");
    const formattedParts = parts.map((part) => {
      return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
    });
    return formattedParts.join(" ");
  };

  const formik = useFormik({
    initialValues: initialValues(manager),
    validationSchema: Yup.object(manager ? updateSquema() : newSchema()),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        formValue.username = formValue.username.toUpperCase();
        formValue.first_name = formatName(formValue.first_name);
        formValue.last_name = formatName(formValue.last_name);
        formValue.curp = formValue.curp.toUpperCase();
        if (manager) await updateManager(manager.id, formValue);
        else await addManager(formValue);

        onRefetch();
        onClose();
      } catch (error) {
        console.error(error);
      }
    },
  });

  useEffect(() => {
    const generateRecommendedUsername = () => {
      const { first_name, last_name, apellido_materno } = formik.values;

      // Generar el nombre de usuario basado en las dos primeras letras del primer y segundo apellido,
      // y la primera letra del nombre
      const firstInitial = first_name.charAt(0).toUpperCase();
      const lastInitials = `${last_name.slice(0, 2)}${apellido_materno.slice(
        0,
        2
      )}`.toUpperCase();
      const username = `${lastInitials}${firstInitial}`;

      setRecommendedUsername(username);
    };

    // Verificar si todos los campos necesarios están completos para generar la recomendación
    const { first_name, last_name, apellido_materno } = formik.values;
    if (first_name && last_name && apellido_materno) {
      generateRecommendedUsername();
    }
  }, [formik.values]);

  //Recuperacion de cargos registrados
  async function getCargosApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/cargo/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setCargos(result);
      return result;
    } catch (error) {}
  }

  useEffect(() => {
    getCargosApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setCargosFormat(formatoDelDropDownCargos(cargos));
  }, [cargos]);

  function formatoDelDropDownCargos(informacionCargo) {
    return map(informacionCargo, (item) => ({
      key: item.id_cargo,
      text: item.descripcion,
      value: item.id_cargo,
    }));
  }

  //Recuperacion de categorias
  async function getCategoriasApi() {
    try {
      const response = await axios.get(`${BASE_API}/api/categoria/`, {
        headers: {
          Authorization: `Bearer ${auth.token}`,
        },
      });
      const result = response.data;
      setCategorias(result);
      return result;
    } catch (error) {}
  }

  useEffect(() => {
    getCategoriasApi();
    // eslint-disable-next-line
  }, [refetch]);

  useEffect(() => {
    setCategoriasFormato(formatoDelDropDownCategorias(categorias));
  }, [categorias]);

  function formatoDelDropDownCategorias(informacionCategoria) {
    return map(informacionCategoria, (item) => ({
      key: item.id_categoria,
      text: item.descripcion,
      value: item.id_categoria,
    }));
  }

  const gradosAcademicosFormato = [
    { key: "1", text: "Licenciatura", value: "Licenciatura" },
    { key: "2", text: "Maestría", value: "Maestría" },
    { key: "3", text: "Doctorado", value: "Doctorado" },
    { key: "4", text: "Diplomatura", value: "Diplomatura" },
    { key: "5", text: "Grado", value: "Grado" },
    { key: "6", text: "Posgrado", value: "Posgrado" },
    { key: "7", text: "Especialización", value: "Especialización" },
    { key: "8", text: "Postdoctorado", value: "Postdoctorado" },
    { key: "9", text: "Máster", value: "Máster" },
    { key: "10", text: "Técnico Superior", value: "Técnico Superior" },
    { key: "11", text: "Ingeniería", value: "Ingeniería" },
    { key: "12", text: "Bachillerato", value: "Bachillerato" },
    { key: "13", text: "Otro", value: "Otro" },
  ];

  return (
    <>
      <div className="divcampo">
        <label className="astedisco">*</label>
        <label className="campR"> Campo requerido</label>
      </div>
      <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
        <label>
          Apellido Paterno <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="last_name"
          placeholder="Apellido paterno"
          value={formik.values.last_name}
          onChange={formik.handleChange}
          error={formik.errors.last_name}
        />
        <label>
          Apellido Materno <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="apellido_materno"
          placeholder="Apellido materno"
          value={formik.values.apellido_materno}
          onChange={formik.handleChange}
          error={formik.errors.apellido_materno}
        />
        <label>
          Nombre <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="first_name"
          placeholder="Nombre(s)"
          value={formik.values.first_name}
          onChange={formik.handleChange}
          error={formik.errors.first_name}
        />
        <label>
          Nombre de usuario <span className="astedisco">*</span>
        </label>
        {recommendedUsername && (
          <span className="recomendacion">
            {" "}
            Nombre de usuario recomendado: {recommendedUsername}
          </span>
        )}
        <Form.Input
          name="username"
          placeholder="nombre de usuario"
          value={formik.values.username}
          onChange={formik.handleChange}
          error={formik.errors.username}
          disabled={!recommendedUsername}
        />
        <label>
          CURP <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="curp"
          placeholder="CURP"
          value={formik.values.curp}
          onChange={(e, { name, value }) => {
            formik.handleChange(e);
            formik.setFieldValue(name, value.toUpperCase());
          }}
          error={formik.errors.curp}
        />
        <label>
          Número de teléfono <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="telefono"
          placeholder="Número de teléfono"
          value={formik.values.telefono}
          onChange={formik.handleChange}
          error={formik.errors.telefono}
        />
        <label>
          Correo electrónico <span className="astedisco">*</span>
        </label>
        <Form.Input
          name="email"
          placeholder="Correo electrónico"
          value={formik.values.email}
          onChange={formik.handleChange}
          error={formik.errors.email}
        />
        <label>
          Grado académico<span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Grado académico"
          fluid
          selection
          search
          options={gradosAcademicosFormato}
          value={formik.values.grado_estudio}
          error={formik.errors.grado_estudio}
          onChange={(_, datos) => {
            formik.setFieldValue("grado_estudio", datos.value);
          }}
        />
        <label>
          Categoría <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Categoría"
          fluid
          selection
          search
          options={categoriasFormato}
          value={formik.values.categoria_asignada}
          error={formik.errors.categoria_asignada}
          onChange={(_, datos) => {
            formik.setFieldValue("categoria_asignada", datos.value);
          }}
        />
        <label>
          Cargo <span className="astedisco">*</span>
        </label>
        <Dropdown
          placeholder="Cargo"
          fluid
          selection
          search
          options={cargosFormato}
          value={formik.values.cargo_asignado}
          error={formik.errors.cargo_asignado}
          onChange={(_, datos) => {
            formik.setFieldValue("cargo_asignado", datos.value);
          }}
        />
        {!manager && (
          <>
            <label>
              Contraseña <span className="astedisco">*</span>
            </label>
            <Form.Input
              name="password"
              type={showPassword ? "text" : "password"}
              placeholder="Contraseña"
              value={formik.values.password}
              onChange={formik.handleChange}
              error={formik.errors.password}
              icon={{
                name: showPassword ? "eye" : "eye slash",
                link: true,
                onClick: () => setShowPassword(!showPassword),
              }}
            />
          </>
        )}
        <div className="add-edit-user-form__active">
          <Checkbox
            toggle
            checked={formik.values.es_docente}
            onChange={(_, data) => {
              formik.setFieldValue("es_docente", data.checked);
            }}
          />
          Docente
        </div>

        {manager && auth.me.id !== manager.id && (
          <div className="add-edit-user-form__active">
            <Checkbox
              toggle
              checked={formik.values.is_active}
              onChange={(_, data) => {
                formik.setFieldValue("is_active", data.checked);
              }}
            />
            Activo en el sistema
          </div>
        )}
        <Button
          type="submit"
          content={manager ? "Actualizar" : "Crear"}
          style={{ backgroundColor: "#008e86", color: "white" }}
          fluid
        />
      </Form>
      <ToastContainer />
    </>
  );
}

function initialValues(datosUsuario) {
  return {
    username: datosUsuario?.username || "",
    telefono: datosUsuario?.telefono || "",
    email: datosUsuario?.email || "",
    first_name: datosUsuario?.first_name || "",
    apellido_materno: datosUsuario?.apellido_materno || "",
    last_name: datosUsuario?.last_name || "",
    password: "",
    curp: datosUsuario?.curp || "",
    categoria_asignada: datosUsuario?.categoria_asignada || "",
    grado_estudio: datosUsuario?.grado_estudio || "",
    cargo_asignado: datosUsuario?.cargo_asignado || "",
    is_active:
      datosUsuario?.is_active === undefined ? true : datosUsuario?.is_active,
    is_staff: true,
    is_superuser:
      datosUsuario?.is_superuser === undefined
        ? true
        : datosUsuario?.is_superuser,
    es_docente: datosUsuario?.es_docente || false,
    es_personal_control_escolar: false,
  };
}

function newSchema() {
  return {
    username: Yup.string()
      .required(true)
      .test(
        "no-spaces",
        "No se permiten espacios en el nombre de usuario",
        (value) => !/\s/.test(value)
      )
      .trim(),
    telefono: Yup.string()
      .required(true)
      .matches(
        /^\d{10}$/,
        "El número de teléfono debe tener 10 dígitos y solo debe contener números"
      ),
    email: Yup.string().email(true).required(true),
    curp: Yup.string()
      .required(true)
      .matches(
        /^[A-Z]{4}\d{6}[HM]{1}[A-Z]{5}[A-Z\d]{1}\d{1}$/,
        "El formato de la CURP no es válido"
      )
      .max(18, "La CURP no debe tener más de 18 caracteres"),

    first_name: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en el nombre"
      ),

    apellido_materno: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en los apellidos"
      ),
    last_name: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en los apellidos"
      ),

    grado_estudio: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en el grado académico"
      ),
    password: Yup.string().required(true),
  };
}
function updateSquema() {
  return {
    username: Yup.string()
      .required(true)
      .test(
        "no-spaces",
        "No se permiten espacios en el nombre de usuario",
        (value) => !/\s/.test(value)
      )
      .trim(),
    telefono: Yup.string()
      .required(true)
      .matches(
        /^\d{10}$/,
        "El número de teléfono debe tener 10 dígitos y solo debe contener números"
      ),
    curp: Yup.string()
      .required(true)
      .matches(
        /^[A-Z]{4}\d{6}[HM]{1}[A-Z]{5}[A-Z\d]{1}\d{1}$/,
        "El formato de la CURP no es válido"
      )
      .max(18, "La CURP no debe tener más de 18 caracteres"),

    first_name: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en el nombre"
      ),

    last_name: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en los apellidos"
      ),

    grado_estudio: Yup.string()
      .required(true)
      .matches(
        /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s']+$/,
        "Solo se permiten letras en el grado académico"
      ),

    email: Yup.string().email(true),
    password: Yup.string(),
  };
}
